import { Button } from '@mui/material';
import Excel from 'exceljs';
import FileSaver from 'file-saver';
import React from 'react';
import {
    MaterialBalanceExceptionsQuery,
    MaterialBalancePageQuery,
} from '../../../../services';

export function MaterialBalanceExportButton({
    records,
    exceptions,
    disabled,
}: {
    records?: MaterialBalancePageQuery['getMaterialBalanceSummary'];
    exceptions?: MaterialBalanceExceptionsQuery['getMaterialBalanceExceptions'];
    disabled: boolean;
}) {
    return (
        <Button
            disabled={disabled}
            onClick={async () => {
                const workbook = new Excel.Workbook();

                const balanceWs = workbook.addWorksheet('Balance');
                balanceWs.addRow([
                    'Año',
                    'Mes',
                    'Semana ISO',
                    'Dia',
                    'Sucursal',
                    'Bobina consumida',
                    'Bolsa producida',
                    'Merma',
                    'Diferencia kg',
                    'Diferencia %',
                    'Corridas',
                    'Corridas sin consumo',
                    'Corridas sin produccion',
                ]);
                records?.forEach((record) => {
                    balanceWs.addRow([
                        record.year,
                        record.month,
                        record.week,
                        record.day,
                        record.branch_name,
                        record.kilos_consumed,
                        record.kilos_produced,
                        record.kilos_waste,
                        record.kilos_difference,
                        record.difference_percentage,
                        record.runs_count,
                        record.runs_without_consumption,
                        record.runs_without_production,
                    ]);
                });

                // One sheet per exception list rather than one combined sheet:
                // they answer different questions and get forwarded to different
                // people.
                const runHeader = [
                    'Corrida',
                    'Fecha',
                    'Turno',
                    'Sucursal',
                    'Maquinas',
                    'Bolsa producida',
                    'Merma',
                    'Bobina consumida',
                ];
                const runRow = (
                    run: MaterialBalanceExceptionsQuery['getMaterialBalanceExceptions']['runs_without_consumption'][number],
                ) => [
                    run.order_production_id,
                    run.start_date,
                    run.shift,
                    run.branch_name,
                    run.machine_names,
                    run.kilos_produced,
                    run.kilos_waste,
                    run.kilos_consumed,
                ];

                const withoutConsumptionWs = workbook.addWorksheet(
                    'Sin consumo',
                );
                withoutConsumptionWs.addRow(runHeader);
                exceptions?.runs_without_consumption.forEach((run) => {
                    withoutConsumptionWs.addRow(runRow(run));
                });

                const withoutProductionWs = workbook.addWorksheet(
                    'Sin produccion',
                );
                withoutProductionWs.addRow(runHeader);
                exceptions?.runs_without_production.forEach((run) => {
                    withoutProductionWs.addRow(runRow(run));
                });

                const productsWs = workbook.addWorksheet('Empacado');
                productsWs.addRow([
                    'Producto',
                    'Descripcion',
                    'Kilos en empacado',
                    'Kilos en maquina de corte',
                    'Kilos vendidos',
                ]);
                exceptions?.products_packed.forEach((product) => {
                    productsWs.addRow([
                        product.product_id,
                        product.product_description,
                        product.kilos_packed,
                        product.kilos_cut,
                        product.kilos_sold,
                    ]);
                });

                const buffer = await workbook.xlsx.writeBuffer();
                FileSaver.saveAs(
                    new Blob([buffer]),
                    'balance-de-materia.xlsx',
                );
            }}
        >
            Exportar
        </Button>
    );
}
